import React from 'react';
import { useCrispVisibility } from '@/hooks/use-crisp-visibility';

// Component to manage Crisp chat visibility within Router context
export const CrispVisibilityManager: React.FC = () => {
  useCrispVisibility();
  return null; // This component doesn't render anything
}; 